import React from 'react';

import makeStyles from '@mui/styles/makeStyles';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip, CircularProgress } from '@mui/material';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

import { green } from '@mui/material/colors';

import TooltipOnCursor from 'components/Shared/TooltipOnCursor';


const useStyles = makeStyles((theme) => ({
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
    tableContainer: {
        maxHeight: '100%',
    },
    tableCellHead: {
        whiteSpace: "nowrap"
    },
    stickyTableCellHead: {
        left: 0,
        position: "sticky",
        zIndex: theme.zIndex.appBar + 2,
        backgroundColor: "#fafafa",
    },
    stickyTableCellBody: {
        minWidth: "50px",
        left: 0,
        position: "sticky",
        zIndex: theme.zIndex.appBar + 1,
        backgroundColor: "#fafafa",
    },
    rowErreur: {
        backgroundColor: "#ff000080",
    },
    pre: {
        whiteSpace: "pre",
    }
}));

export default function CheckImportConditionsSAVDialog({ checkImportData, onCancel, onClickImport, importing}) {

    const classes = useStyles();


    const getClassName = (ligne) => {

        if (!ligne.result) {
            return classes.rowErreur;
        }

        if (ligne.status === 0) {
            return classes.row;
        }

        if (ligne.status === 1) {
            return classes.rowModifie;
        }

        if (ligne.status === 2) {
            return classes.rowNonModifie;
        }

        return "";

    }


    const getTooltipTitle = (ligne) => {

        if (!ligne.result) {
            return ligne.erreur;
        }

        if (ligne.status === 0) {
            return "Nouvelle condition";
        }

        if (ligne.status === 1) {
            return "Condition modifiée";
        }

        if (ligne.status === 2) {
            return "Condition inchangée";
        }

        return "";

    }
    


    const getArticles = (ligne) => {
        if (ligne.articles && ligne.libelle) {
            return (
                <Tooltip title={ligne.libelle}>
                    <p>{ligne.articles}</p>
                </Tooltip>
            );
        }
        return ligne.articles;
    }

    const getSousFamilles = (ligne) => {
        if (ligne.sousFamilles && ligne.libelle) {
            return (
                <Tooltip title={ligne.libelle}>
                    <p>{ligne.sousFamilles}</p>
                </Tooltip>
            );
        }
        return ligne.sousFamilles;
    }

    const getFamilles = (ligne) => {
        if (ligne.familles && ligne.libelle) {
            return (
                <Tooltip title={ligne.libelle}>
                    <p>{ligne.familles}</p>
                </Tooltip>
            );
        }
        return ligne.familles;
    }


    const getResponsableContact = (ligne) => {
        if (ligne.responsableContactModifie) {
            return (
                <Tooltip title={ligne.responsableContactPrecedent}>
                    <i>{ligne.responsableContact}</i>
                </Tooltip>
            );
        }
        return ligne.responsableContact;
    }

    const getResponsableTelephone = (ligne) => {
        if (ligne.responsableTelephoneModifie) {
            return (
                <Tooltip title={ligne.responsableTelephonePrecedent}>
                    <i>{ligne.responsableTelephone}</i>
                </Tooltip>
            );
        }
        return ligne.responsableTelephone;
    }

    const getResponsableEmail = (ligne) => {
        if (ligne.responsableEmailModifie) {
            return (
                <Tooltip title={ligne.responsableEmailPrecedent}>
                    <i>{ligne.responsableEmail}</i>
                </Tooltip>
            );
        }
        return ligne.responsableEmail;
    }

    const getStandardTelephoniqueNumero = (ligne) => {
        if (ligne.standardTelephoniqueNumeroModifie) {
            return (
                <Tooltip title={ligne.standardTelephoniqueNumeroPrecedent}>
                    <i>{ligne.standardTelephoniqueNumero}</i>
                </Tooltip>
            );
        }
        return ligne.standardTelephoniqueNumero;
    }

    const getStandardTelephoniqueHoraires = (ligne) => {
        if (ligne.standardTelephoniqueHorairesModifie) {
            return (
                <Tooltip title={ligne.standardTelephoniqueHorairesPrecedent}>
                    <i>{ligne.standardTelephoniqueHoraires}</i>
                </Tooltip>
            );
        }
        return ligne.standardTelephoniqueHoraires;
    }

    const getDelaiReference = (ligne) => {
        if (ligne.delaiReferenceModifie) {
            return (
                <Tooltip title={ligne.delaiReferencePrecedent}>
                    <i>{ligne.delaiReference}</i>
                </Tooltip>
            );
        }
        return ligne.delaiReference;
    }


    const getDelaiExtensionGarantie = (ligne) => {
        if (ligne.delaiExtensionGarantieModifie) {
            return (
                <Tooltip title={ligne.delaiExtensionGarantiePrecedent ? ligne.delaiExtensionGarantiePrecedent : "null"}>
                    <i>{ligne.delaiExtensionGarantie}</i>
                </Tooltip>
            );
        }
        return ligne.delaiExtensionGarantie;
    }

    const getAdresse = (ligne) => {
        if (ligne.adresseModifie) {
            return (
                <Tooltip title={ligne.adressePrecedent}>
                    <i><span className={classes.pre}>{ligne.adresse}</span></i>
                </Tooltip>
            );
        }
        return (<span className={classes.pre}>{ligne.adresse}</span>);
    }

    const getPieceJoindreColis = (ligne) => {
        if (ligne.pieceJoindreColisModifie) {
            return (
                <Tooltip title={ligne.pieceJoindreColisPrecedent}>
                    <span className={classes.pre}><i>{ligne.pieceJoindreColis}</i></span>
                </Tooltip>
            );
        }
        return (<span className={classes.pre}>{ligne.pieceJoindreColis}</span>);
    }

    const getPerimetreApplicationSAV = (ligne) => {
        if (ligne.perimetreApplicationSAVModifie) {
            return (
                <Tooltip title={ligne.perimetreApplicationSAVPrecedent}>
                    <i><span className={classes.pre}>{ligne.perimetreApplicationSAV}</span></i>
                </Tooltip>
            );
        }
        return (<span className={classes.pre}>{ligne.perimetreApplicationSAV}</span>);
    }

    const getPreconisationFacturationClient = (ligne) => {
        if (ligne.preconisationFacturationClientModifie) {
            return (
                <Tooltip title={ligne.preconisationFacturationClientPrecedent}>
                    <i><span className={classes.pre}>{ligne.preconisationFacturationClient}</span></i>
                </Tooltip>
            );
        }
        return (<span className={classes.pre}>{ligne.preconisationFacturationClient}</span>);
    }

    const getReglePriseEnChargePort = (ligne) => {
        if (ligne.reglePriseEnChargePortModifie) {
            return (
                <Tooltip title={ligne.reglePriseEnChargePortPrecedent}>
                    <i><span className={classes.pre}>{ligne.reglePriseEnChargePort}</span></i>
                </Tooltip>
            );
        }
        return (<span className={classes.pre}>{ligne.reglePriseEnChargePort}</span>);
    }


    const getEngagementDelaiResolution = (ligne) => {
        if (ligne.engagementDelaiResolutionModifie) {
            return (
                <Tooltip title={ligne.engagementDelaiResolutionPrecedent}>
                    <i><span className={classes.pre}>{ligne.engagementDelaiResolution}</span></i>
                </Tooltip>
            );
        }
        return (<span className={classes.pre}>{ligne.engagementDelaiResolution}</span>);
    }

    const getCommentaire = (ligne) => {
        if (ligne.commentaireModifie) {
            return (
                <Tooltip title={ligne.commentairePrecedent}>
                    <i><span className={classes.pre}>{ligne.commentaire}</span></i>
                </Tooltip>
            );
        }
        return (<span className={classes.pre}>{ligne.commentaire}</span>);
    }

    

    return (

        <Dialog open={!!checkImportData} fullScreen>

            {!!checkImportData && (
                    <>         

                        <DialogTitle>Import de conditions SAV</DialogTitle>
                        <DialogContent>

                        <TableContainer component={Paper} className={classes.tableContainer}>
                            <Table stickyHeader className={classes.table} size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow> 
                                        <TableCell component='td' className={classes.stickyTableCellHead}>#Ligne</TableCell>
                                        <TableCell className={classes.tableCellHead}>Code type</TableCell>
                                        <TableCell className={classes.tableCellHead}>Code fournisseur</TableCell>
                                        <TableCell className={classes.tableCellHead}>Périmètre</TableCell>
                                        <TableCell className={classes.tableCellHead}>Nom fournisseur</TableCell>
                                        <TableCell className={classes.tableCellHead}>ARTICLE</TableCell>
                                        <TableCell className={classes.tableCellHead}>Code Sous-Famille (6 caractères)</TableCell>
                                        <TableCell className={classes.tableCellHead}>Code Famille (4 caractères)</TableCell>
                                        <TableCell className={classes.tableCellHead}>Contact Responsable SAV</TableCell>
                                        <TableCell className={classes.tableCellHead}>Téléphone Responsable SAV</TableCell>
                                        <TableCell className={classes.tableCellHead}>Mail Responsable SAV</TableCell>
                                        <TableCell className={classes.tableCellHead}>Standard téléphonique</TableCell>
                                        <TableCell className={classes.tableCellHead}>Horaires standard téléphonique</TableCell>
                                        <TableCell className={classes.tableCellHead}>Délai de référence (nb jour)</TableCell>
                                        <TableCell className={classes.tableCellHead}>Délai extension de garantie(en nb de jour)</TableCell>
                                        <TableCell className={classes.tableCellHead}>Adresse d'envoi/de retour du SAV OBLIGATOIRE</TableCell>
                                        <TableCell className={classes.tableCellHead}>Pièce à joindre dans le colis</TableCell>
                                        <TableCell className={classes.tableCellHead}>Périmetre d'application SAV</TableCell>
                                        <TableCell className={classes.tableCellHead}>Préconisation de facturation client</TableCell>
                                        <TableCell className={classes.tableCellHead}>Règle prise en charge Port</TableCell>
                                        <TableCell className={classes.tableCellHead}>Engagement délai de résolution</TableCell>
                                        <TableCell className={classes.tableCellHead}>Commentaire</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {checkImportData.conditionsSAV.map((ligne) => (
                                        <TooltipOnCursor key={ligne.ligne} title={getTooltipTitle(ligne)}>
                                            <TableRow className={getClassName(ligne)}>
                                                <TableCell className={classes.stickyTableCellBody}>{ligne.ligne}</TableCell>
                                                <TableCell>{ligne.garantieTypeString}</TableCell>
                                                <TableCell>{ligne.fournisseurCode}</TableCell>
                                                <TableCell>{ligne.perimetre}</TableCell>
                                                <TableCell>{ligne.fournisseurNom}</TableCell>
                                                <TableCell>{getArticles(ligne)}</TableCell>
                                                <TableCell>{getSousFamilles(ligne)}</TableCell>
                                                <TableCell>{getFamilles(ligne)}</TableCell>

                                                <TableCell>{getResponsableContact(ligne)}</TableCell>
                                                <TableCell>{getResponsableTelephone(ligne)}</TableCell>
                                                <TableCell>{getResponsableEmail(ligne)}</TableCell>
                                                <TableCell>{getStandardTelephoniqueNumero(ligne)}</TableCell>
                                                <TableCell>{getStandardTelephoniqueHoraires(ligne)}</TableCell>

                                                <TableCell>{getDelaiReference(ligne)}</TableCell>
                                                <TableCell>{getDelaiExtensionGarantie(ligne)}</TableCell>
                                                <TableCell>{getAdresse(ligne)}</TableCell>
                                                <TableCell>{getPieceJoindreColis(ligne)}</TableCell>
                                                <TableCell>{getPerimetreApplicationSAV(ligne)}</TableCell>
                                                <TableCell>{getPreconisationFacturationClient(ligne)}</TableCell>
                                                <TableCell>{getReglePriseEnChargePort(ligne)}</TableCell>
                                                <TableCell>{getEngagementDelaiResolution(ligne)}</TableCell>
                                                <TableCell>{getCommentaire(ligne)}</TableCell>
                                            </TableRow>
                                        </TooltipOnCursor>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>


                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onCancel} color="primary">
                            Annuler
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={onClickImport}
                                disabled={importing || !checkImportData.result}
                            >
                                Importer
                                {importing && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </Button>

                        </DialogActions>


                    </>
            )}

        </Dialog>
    );


}